module.exports = __webpack_public_path__ + "img/张小琴.cf5caa07.jpg";